export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тип адреса"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тип счета"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Название"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать адрес"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать счет"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создание нового адреса"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать новый счет"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите название"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите валюту"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите тип"])}
}